import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';

import {
  getUsersSuccessAction,
  getUserSuccessAction,
  setUsersIsLoadingAction,
  createUserSuccessAction,
  updateUserSuccessAction,
  setUsersCountAction,
  setCurrentUserAction,
  checkEmailExistSuccessAction,
} from './Actions';

import {
  errorNotificationFromError,
  newErrorNotificationAction,
  newSuccessNotificationAction,
} from '../notifications/Actions';

import * as api from './Api';

import { createArtisanAction } from '../artisans/Actions';
import { createSupplierAction } from '../suppliers/Actions';
import { createCustomerAction } from '../customers/Actions';
import { createApplicantAction } from '../applicants/Actions';
import { setRedirectFalse, setRedirectTrue } from '../globalFail/Action';

import { push } from 'connected-react-router';

function* getUser({ payload }) {
  const userId = payload;

  try {
    yield put(setUsersIsLoadingAction(true));
    const response = yield call(api.getUser, userId);
    const { data: user } = response;
    yield put(getUserSuccessAction(user));
    yield put(setCurrentUserAction(user));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setUsersIsLoadingAction(false));
  }
}

function* createUser({ payload, ids, setPage }) {
  yield put(setRedirectFalse());
  const { artisan, supplier, customer, applicant, ...userData } = payload;
  const { userType, ...userDataWithoutUserType } = userData;
  console.log(userDataWithoutUserType);
  try {
    yield put(setUsersIsLoadingAction(true));

    const response = yield call(api.createUser, {
      ...userDataWithoutUserType,
      userType: ['2'],
    });
    yield put(setRedirectTrue());
    const { data } = response;
    const user = data;
    yield put(createUserSuccessAction(user));
    yield put(setCurrentUserAction(user));
    const { _id } = data;
    const userID = _id;
    console.log(ids, ids.indexOf('5'));
    // if (ids.indexOf('5') !== -1) {
    //   yield put(createSupplierAction({ userID, ...supplier }));
    // } else if (ids.indexOf('6') !== -1) {
    //   yield put(createApplicantAction({ userID, ...applicant }));
    // } else if (ids.indexOf('3') !== -1) {
    //   yield put(createArtisanAction({ userID, ...artisan }));
    // } else if (ids.indexOf('4') !== -1) {
    //   yield put(createCustomerAction({ userID, ...customer }));
    //   yield put(createUserSuccessAction(user));
    yield put(newSuccessNotificationAction(`Created User : ${user.firstName}`));
    // yield put(push('/users'));
    // }
  } catch (error) {
    yield put(errorNotificationFromError(error));
    // yield put(setGlobalFail(true))
    yield put(setRedirectFalse());
  } finally {
    yield put(setUsersIsLoadingAction(false));
  }
}

function* changeUserPassword({ payload }) {
  try {
    yield call(api.changePassword, payload);
    yield put(newSuccessNotificationAction('Password Updated'));
  } catch (error) {
    yield put(newErrorNotificationAction(error));
  } finally {
  }
}

function* updateUser({ payload: { id, formData } }) {
  try {
    yield put(setUsersIsLoadingAction(true));
    const response = yield call(api.updateUser, id, formData);
    const { data } = response;
    const updatedUser = data;
    yield put(updateUserSuccessAction(updatedUser));
    yield put(
      newSuccessNotificationAction(`Updated User : ${updatedUser.firstName}`)
    );
    yield put(push('/users'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setUsersIsLoadingAction(false));
  }
}

function* updateUserSettings({ payload: { id: values } }) {
  try {
    yield put(setUsersIsLoadingAction(true));
    const response = yield call(
      api.updateUserSettings,
      values.userId,
      values.values
    );
    console.log(response);
    const updatedUser = response;
    yield put(updateUserSuccessAction(updatedUser));
    yield put(newSuccessNotificationAction(`Updated User `));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setUsersIsLoadingAction(false));
  }
}

function* getUsers({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    sort: 'email',
    dir: 'asc',
  };

  const body = { ...defData, ...payload };
  try {
    yield put(setUsersIsLoadingAction(true));
    const response = yield call(api.getUsers, body);
    const { data } = response;
    const count = data.count;
    const users = data.content;
    yield put(setUsersCountAction(count));
    yield put(getUsersSuccessAction(users));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setUsersIsLoadingAction(false));
  }
}

function* checkEmailExists({ payload }) {
  const email = payload;
  try {
    yield call(api.checkEmailExist, { email });
    yield put(checkEmailExistSuccessAction(false));
  } catch (error) {
    yield put(checkEmailExistSuccessAction(true));
  }
}

export default function*() {
  yield takeLatest(actions.GET_USERS_ACTION, getUsers);
  yield takeLatest(actions.GET_USER_ACTION, getUser);
  yield takeLatest(actions.CREATE_USER_ACTION, createUser);
  yield takeLatest(actions.UPDATE_USER_ACTION, updateUser);
  yield takeLatest(actions.UPDATE_USER_SETTINGS_ACTION, updateUserSettings);
  yield takeLatest(actions.CHECK_EMAIL_EXIST_ACTION, checkEmailExists);
  yield takeLatest(actions.CHANGE_USER_PASSWORD, changeUserPassword);
}
